/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MySpinWheelConfigIdResponse
 */
export interface MySpinWheelConfigIdResponse {
    /**
     * The FuelUpSpinWheelConfig id resolved for the requesting user.
     * @type {string}
     * @memberof MySpinWheelConfigIdResponse
     */
    spinWheelConfigId: string;
}

/**
 * Check if a given object implements the MySpinWheelConfigIdResponse interface.
 */
export function instanceOfMySpinWheelConfigIdResponse(value: object): value is MySpinWheelConfigIdResponse {
    if (!('spinWheelConfigId' in value) || value['spinWheelConfigId'] === undefined) return false;
    return true;
}

export function MySpinWheelConfigIdResponseFromJSON(json: any): MySpinWheelConfigIdResponse {
    return MySpinWheelConfigIdResponseFromJSONTyped(json, false);
}

export function MySpinWheelConfigIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MySpinWheelConfigIdResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'spinWheelConfigId': json['spinWheelConfigId'],
    };
}

export function MySpinWheelConfigIdResponseToJSON(json: any): MySpinWheelConfigIdResponse {
    return MySpinWheelConfigIdResponseToJSONTyped(json, false);
}

export function MySpinWheelConfigIdResponseToJSONTyped(value?: MySpinWheelConfigIdResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spinWheelConfigId': value['spinWheelConfigId'],
    };
}

